import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckGroupAdminWidgetComponent } from './component/truck-group-admin.component';
import { TruckGroupAdminModule } from '../../../components/truck-group-admin/truck-group-admin.module';

@NgModule({
  imports: [
    CommonModule,
    TruckGroupAdminModule,
  ],
  declarations: [TruckGroupAdminWidgetComponent]
})
export class TruckGroupAdminWidgetModule { }
